<div class="card-skeleton-list fade-element-in-only overflow-auto">
  <div class="skeleton-card layout-row" *ngFor="let row of skeletonRows">

    <div class="skeleton-index-border">
      <div class="bringoz-skeleton bringoz-skeleton-dark"></div>
    </div>

    <div class="flex layout-column padding-left-5">

      <div class="skeleton-title-row layout-row layout-align-start-center gap-10">
        <div class="bringoz-skeleton skeleton-checkbox"></div>
        <div class="bringoz-skeleton" style="width: 60px; height: 18px;"></div>
        <div class="bringoz-skeleton" style="width: 130px; height: 18px;"></div>
      </div>

      <div class="layout-row layout-wrap">
        <div class="flex-50 skeleton-info-row layout-row layout-align-start-center gap-10">
          <div class="bringoz-skeleton skeleton-icon"></div>
          <div class="bringoz-skeleton bringoz-skeleton-text" style="width: 70%; height: 14px;"></div>
        </div>
        <div class="flex-50 skeleton-info-row layout-row layout-align-start-center gap-10">
          <div class="bringoz-skeleton skeleton-icon"></div>
          <div class="bringoz-skeleton bringoz-skeleton-text" style="width: 60%; height: 14px;"></div>
        </div>
        <div class="flex-50 skeleton-info-row layout-row layout-align-start-center gap-10">
          <div class="bringoz-skeleton skeleton-icon"></div>
          <div class="bringoz-skeleton bringoz-skeleton-text" style="width: 55%; height: 14px;"></div>
        </div>
        <div class="flex-50 skeleton-info-row layout-row layout-align-start-center gap-10">
          <div class="bringoz-skeleton skeleton-icon"></div>
          <div class="bringoz-skeleton bringoz-skeleton-text" style="width: 75%; height: 14px;"></div>
        </div>
      </div>

    </div>

  </div>
</div>
